//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'vue-twentytwenty/dist/vue-twentytwenty.css';
import TwentyTwenty from 'vue-twentytwenty';

export default {
  data: function () {
    return {
      percentWidthImage: 50,

      isMousemove: false
    }
  },

  props: {
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    activeProductId: {
      type: [String, Number],
      default: null
    }
  },

  components: {
    TwentyTwenty
  },

  created: function () {
    if (Object.keys(this.option || {}).length > 0) {
      this.ssrOpenModal();
    }
  },

  computed: {
    isVisibleImages: function () {
      return Boolean((this.option?.images_ids || []).length >= 2)
    },

    imageBefore: function () {
      return this.$img((this.option?.images_ids?.[0] || '').toString(), {width: 950, height: 600, fit: 'crop'})
    },
    imageAfter: function () {
      return this.$img((this.option?.images_ids?.[1] || '').toString(), {width: 950, height: 600, fit: 'crop'})
    },
  },

  watch: {
    option: function () {
      if (Object.keys(this.option || {}).length > 0) {
        this.$modal.show("ochki-modal-option");
      }
    }
  },

  methods: {
    close: function () {
      window.history.replaceState(null, null, this.$route.path);
      this.$emit("close");
    },


    modalOpened: function () {
      if (!process?.client) {
        return
      }

      const newUrl = [
        this.$route?.path,
        `?product-id=${this.activeProductId}&option=${this.option?.id}`
      ].join("");
      window.history.replaceState(null, null, newUrl);
    },


    ssrOpenModal: function () {
      if (!this.$refs.refModal) {
        setTimeout(() => {
          this.ssrOpenModal();
        }, 10)

        return
      }
      this.$refs.refModal.open();
    }
  }
};
